import React from "react";
import { getPendingScoredUploadPaths, getScoredCaseSourceChoices } from "./BookingMonitorWorkflow";

const BookingMonitorScoredSources = ({
  ep = {}, bookingPath = "", selectedPath = "", onSelect, disabled = false,
}) => {
  const sources = getScoredCaseSourceChoices(ep);
  const pendingUploads = getPendingScoredUploadPaths(ep, bookingPath);
  const doctorCopied = ["copied_to_client", "returned_to_center"].includes(ep.doctorTransferStatus);

  return (
    <div aria-label="Scored file sources">
      {onSelect && (
        <div className="mb-3">
          <label className="font-weight-bold" htmlFor="reviewed-scored-source">
            Approved scored files for the doctor
          </label>
          <select
            id="reviewed-scored-source"
            className="form-control"
            value={selectedPath}
            onChange={(event) => onSelect(event.target.value)}
            disabled={disabled || pendingUploads.length > 0 || !sources.length}
          >
            <option value="">Select the reviewed version</option>
            {sources.map((source) => (
              <option key={source.id} value={source.path}>
                {source.label}: {source.fileName}
              </option>
            ))}
          </select>
          <div className="small text-muted mt-2">
            Review each version before selecting. Identical names are kept separately.
            Deleting unused files does not complete the review. To use a merge, prepare
            the case's _Merge folder at the center and refresh after it is recorded.
          </div>
        </div>
      )}
      {pendingUploads.length > 0 && (
        <div className="small text-warning mb-2" role="status">
          Waiting for center download/extract of {pendingUploads.length} scored ZIP(s).
          Doctor assignment stays blocked.
        </div>
      )}
      {sources.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-sm table-bordered mb-2">
            <caption className="sr-only">Received scored versions for this case</caption>
            <thead><tr><th scope="col">Source</th><th scope="col">File / center folder</th></tr></thead>
            <tbody>
              {sources.map((source) => (
                <tr key={source.id}>
                  <td>
                    {source.label}
                    {ep.officeScoreMultiFileReviewStatus === "reviewed" &&
                      ep.officeScoreExtractPath === source.path && (
                        <span className="badge badge-success d-block mt-1">Approved</span>
                      )}
                  </td>
                  <td style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <div>{source.fileName}</div>
                    <div className="small text-muted">{source.path}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="small text-muted">
          No scored versions recorded at center yet. Wait for the client return or
          scored upload download/extract, then refresh the monitor.
        </div>
      )}
      {doctorCopied && (
        <div className="small text-muted">
          Doctor copy confirmed. Center cleans the working folders; reviewed versions
          are archived and final doctor results are retained.
        </div>
      )}
    </div>
  );
};

export default BookingMonitorScoredSources;
